/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Recurrence_Interval_WeeklyInputs */

const en_enum_recurrence_interval_weekly = /** @type {(inputs: Enum_Recurrence_Interval_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interval Weekly`)
};

const de_enum_recurrence_interval_weekly = /** @type {(inputs: Enum_Recurrence_Interval_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervall Weekly`)
};

/**
* | output |
* | --- |
* | "Interval Weekly" |
*
* @param {Enum_Recurrence_Interval_WeeklyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_recurrence_interval_weekly = /** @type {((inputs?: Enum_Recurrence_Interval_WeeklyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Recurrence_Interval_WeeklyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_recurrence_interval_weekly(inputs)
	return de_enum_recurrence_interval_weekly(inputs)
});